import './style.scss';
import Swiper from 'swiper';
import 'swiper/swiper.scss';
import {EffectFade, Autoplay} from 'swiper/modules';
import 'swiper/modules/effect-fade.css';

export function testimonial_block() {
    const blocks = document.querySelectorAll('.testimonial_block');
    if (!blocks.length) return;

    blocks.forEach(block => {
        const swiperContainer = block.querySelector('.testimonials-swiper');
        if (!swiperContainer) return;

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 1,
            spaceBetween: 40,
            loop: true,
            mousewheel: true,
            effect: 'fade',
            speed: 3000,
            modules: [EffectFade, Autoplay],
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            }
        });

        // Initialize stopped
        swiper.autoplay.stop();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    swiper.autoplay.start();
                } else {
                    swiper.autoplay.stop();
                }
            });
        }, {
            threshold: 0.1 // Trigger when 10% of the block is visible
        });

        observer.observe(block);
    });
}
